<div class="custom-carousel">
  <div class="carousel-container">
    @for (slide of slides; track $index) {
    <div class="carousel-slide" [ngClass]="{ active: isActiveSlide($index) }">
      <div class="carousel-items">
        @for (item of slide; track item.uid) {
        <a class="carousel-item" [attr.href]="item.urlLink" [attr.target]="item.external == 'true' ? '_blank' : null">
          @if (item.headline) {
          <p [innerHTML]="item.headline"></p>
          }
          <cx-media [container]="item.media"></cx-media>
          @if (item.content) {
          <p [innerHTML]="item.content"></p>
          }
        </a>
        }
      </div>
    </div>
    }
  </div>
  <button class="carousel-control prev" (click)="prevSlide()" [ngClass]="{disable: isPrevDisabled()}"
    [disabled]="isPrevDisabled()">
    <cx-icon class="cx-icon fas fa-angle-left flip-at-rtl"></cx-icon>
  </button>
  <button class="carousel-control next" (click)="nextSlide()" [ngClass]="{disable: isNextDisabled()}"
    [disabled]="isNextDisabled()">
    <cx-icon class="cx-icon fas fa-angle-right flip-at-rtl"></cx-icon>
  </button>

  <div class="carousel-indicators">
    @for (slide of slides; track $index) {
    <span class="indicator" [ngClass]="{ active: isActiveSlide($index) }" (click)="activeSlideIndex = $index">
    </span>
    }
  </div>
</div>
